export default "__VITE_ASSET__716da467__"